import { render } from "./_ModalFrame.vue?vue&type=template&id=2836285b"
import script from "./_ModalFrame.vue?vue&type=script&lang=js"
export * from "./_ModalFrame.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/common/_ModalFrame.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2836285b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2836285b', __exports__)) {
    api.reload('2836285b', __exports__)
  }
  
  module.hot.accept("./_ModalFrame.vue?vue&type=template&id=2836285b", () => {
    api.rerender('2836285b', render)
  })

}


export default __exports__